import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "../../styles/Login.css";
import loginImg from "../../assets/loginImage.jpeg";
import LoadingComponent from "../../components/common/Loading";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/Logo.png";
import { EMAIL_REGEX } from "../../constants/common";

function ProviderLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false); // State for loading
  const [showPassword, setShowPassword] = useState(false); // State for showing password

  const navigate = useNavigate();

  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email.trim() === "" || password.trim() === "") {
      setSubmitted(true); // Set submitted to true when form is submitted
      return;
    }
    const payload = {
      email,
      password,
    };

    if (!EMAIL_REGEX.test(email)) {
      toast.error("Invalid email address");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        "https://yelospace.com/api/authenticate/provider",
        payload
      );
      if (response.data.status === 401) {
        toast.error("Invaild Email or Password");
        //console.log"Unauthorized User");
      }
      const data = JSON.stringify({
        userData: response?.data?.response,
        jwt: response?.data?.response?.jwt,
        role: "provider",
      });
      if (response.data.status === 200) {
        localStorage.setItem("data", data);
        localStorage.setItem("role", "provider");
        navigate("/provider-listing");
      }
    } catch (error) {
      console.error("Error occurred:", error);
    } finally {
      setLoading(false); // Finish loading
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (location?.state?.signUp) {
      //console.loglocation.state.signup);
      window.history.replaceState({}, "");
      toast.success("Congratulations! You have successfully Signed Up");
    }
  }, []);
  return (
    <>
      <ToastContainer />
      {/* <Navbar /> */}
      <div className="login-container">
        <div className="w-100 d-flex justify-content-center">
          <div className="left-panel">
            <img src={loginImg} alt="Left Panel Image" />
          </div>
          <div className="right">
            <div className="w-100 d-flex justify-content-center">
              <Link to="/">
                <img src={logo} className="logo-img" alt="Left Panel Image" />
              </Link>
            </div>

            <div className="w-100 d-flex justify-content-center">
              <h3>Login as Provider</h3>
            </div>
            <form className="w-100" onSubmit={handleSubmit}>
              <div className="w-100">
                <input
                  type="email"
                  name="email"
                  placeholder="Email *"
                  value={email}
                  className="form-control w-75 mx-auto p-2 bg-color"
                  onChange={handleEmailChange}
                />
                {submitted && email.trim() === "" && (
                  <span className="login-error">Email is required</span>
                )}
              </div>
              <div className="w-100">
                <div className="password-input-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password *"
                    className="form-control w-75 mx-auto mt-3 p-2 bg-color"
                    value={password}
                    onChange={handlePasswordChange}
                  />
                  {/* Eye icon */}
                  <span
                    className="password-toggle-btn"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? (
                      <FontAwesomeIcon icon={faEyeSlash} />
                    ) : (
                      <FontAwesomeIcon icon={faEye} />
                    )}
                  </span>
                </div>

                {submitted && password.trim() === "" && (
                  <span className="login-error">Password is required</span>
                )}
              </div>
              <div className="w-100 d-flex justify-content-center">
                <button
                  type="submit"
                  disabled={loading ? true : false}
                  className="submit-btn mx-auto mt-4"
                >
                  {loading ? "Processing..." : "Login"}
                </button>
              </div>
            </form>
            <div className="forgot-password">
              <a href="/provider-forget-password">Forgot password?</a>
            </div>

            <div className="d-flex justify-content-center w-100">
              <p className="signup-link">
                New user? <Link to="/provider-signup">Sign up</Link>
              </p>
            </div>
            <div className="d-flex justify-content-center w-100 mt-4">
              <div className="continue">
                <Link
                  onClick={() => localStorage.setItem("role", "Guest")}
                  className="border py-3 px-3"
                  style={{ fontWeight: "bold" }}
                  to="/provider-business/new"
                >
                  Post without Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProviderLogin;
